import React from 'react'

import Img from 'gatsby-image/withIEPolyfill'


const Image = ({ imagePC, imageSP, className, alt, minWidth = 769 }) => {

    if (imagePC || imageSP) {

        if (imagePC && imageSP && imagePC.localFile.childImageSharp.fluid.src !== imageSP.localFile.childImageSharp.fluid.src) {
            const sources = [
                { ...imagePC.localFile.childImageSharp.fluid, media: `(min-width: ${minWidth}px)` },
                { ...imageSP.localFile.childImageSharp.fluid }
            ]
            return <Img fluid={sources} className={className} fadeIn={true} alt={alt || ""} />
        } else {
            return <Img fluid={imagePC.localFile.childImageSharp.fluid} className={className} fadeIn={true} alt={alt || ""} />
        }
    } else {
        return null
    }

    
}

export default Image